import axios from "axios";
import SonicApplication, {
  SonicApplicationData,
} from "../../../common/classes/SonicApplication";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

export const getProjectApplications = async (
  args: {
    auth_token: string;
    project_id: string;
    is_jikei_request: boolean;
  },
  signal?: AbortSignal
) => {
  try {
    const res = await axios.get(
      getAPIRoot(
        APIRoutes.get.project_applications,
        !args.is_jikei_request ? "admin" : "jikei"
      ),
      {
        params: {
          project_id: args.project_id,
        },
        headers: {
          "X-Sonic-Auth": args.auth_token,
        },
        signal,
      }
    );

    if (res.data.result === true) {
      const applications: Array<SonicApplicationData> = [];

      res.data.message.applications.forEach((a: any) => {
        const application = SonicApplication.parseFromAPIResponse(a);

        applications.push(application);
      });

      return {
        applications: applications,
      };
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
